import React from 'react';
import { Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { CheckCircle } from '@mui/icons-material';
import PropTypes from 'prop-types';

import { moment } from '../../../../../../../I18n';
import EmptyState from '../../../../../../DesignSystem/EmptyState';

function EmptyEnded({ endAt, activeStep = {} }: any) {
  const intl = useIntl();
  const formattedEndAt = moment(activeStep.end_at || endAt).format(
    intl.formatMessage({ id: 'MOMENT.DATE.DEFAULT' }),
  );

  let textKey = 'POSTS.CONSULTATIONS.STEP_ENDED_AT';
  if (!activeStep?.label) textKey = 'POSTS.CONSULTATIONS.ENDED_AT';

  const title = (
    <Typography variant="body1">
      <FormattedMessage id={textKey} values={{ date: formattedEndAt, step: activeStep.label }} />
    </Typography>
  );

  return (
    <EmptyState content={title} icon={<CheckCircle color="primary" style={{ fontSize: 32 }} />} />
  );
}

EmptyEnded.propTypes = {
  endAt: PropTypes.string,
  activeStep: PropTypes.shape({
    end_at: PropTypes.string,
    label: PropTypes.string,
  }),
};
export default EmptyEnded;
